module.exports = "/_next/static/images/Hero@2x-cb1694d069d5a43f5bf91f366f16466d.png";